import TextField from '@maison/components/form/fields/TextField.vue';
import FormGroup from '@maison/components/form/FormGroup.vue';
import { defineAsyncComponent } from 'vue';
import { mapActions, mapState } from 'vuex';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';
import formBasicMixin from '@phoenix/mixins/formBasicMixin';
import formAddressFieldsMixin from '@phoenix/mixins/formAddressFieldsMixin';

export default {
  components: {
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
    TextField,
    FormGroup,
  },

  mixins: [formBasicMixin, formAddressFieldsMixin],

  props: {
    productTracking: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isPhoneVerified: false,
      fields: {
        reference: {
          id: 'reference',
          name: 'reference',
          value: '',
        },
        country: {
          id: 'country',
          name: 'country',
          label: this.$t('Form.label.country'),
          value: null,
          options: [],
          required: true,
        },
        email: {
          id: 'email',
          name: 'email',
          label: this.$t('Form.label.email'),
          value: '',
          required: true,
        },
        firstName: {
          id: 'firstName',
          name: 'firstName',
          label: this.$t('Form.label.firstName'),
          value: '',
          required: true,
        },
        lastName: {
          id: 'lastName',
          name: 'lastName',
          label: this.$t('Form.label.lastName'),
          value: '',
          required: true,
        },
        phoneNumber: {
          id: 'phoneNumber',
          name: 'phoneNumber',
          label: this.$t('Form.label.phone'),
          value: '',
          required: false,
          type: 'phone',
        },
        newsletter: {
          id: 'newsletter',
          name: 'newsletter',
          label: this.$t('Form.stayInTouch', {
            privacyLink: this.privacyLink,
          }),
          type: 'checkbox',
          value: false,
        },
      },
    };
  },

  computed: {
    ...mapState('currentUser', ['customerInfo']),

    action() {
      return window.route('api.form.stock.subscribe');
    },

    descriptionText() {
      return this.$t('Product.stock.modalDescription', {
        reference: this.fields.reference.value,
      });
    },

    isBackInStockCommerceApiEnabled() {
      return getFeatureFlag(FEATURE_FLAG.BACK_IN_STOCK_WITH_COMMERCEAPI);
    },

    isPhoneVerificationEnabled() {
      return getFeatureFlag(FEATURE_FLAG.BACK_IN_STOCK_COMMERCEAPI_WITH_PHONE);
    },

    isCnCountry() {
      return window.Phoenix.currentCountry === 'CN';
    },
  },

  methods: {
    ...mapActions('currentUser', ['loadCustomerInfo']),

    resetStockNotificationForm() {
      Object.entries(this.fields).forEach(([name, field]) => {
        if (!['country', 'reference'].includes(name)) {
          field.value = field.type === 'checkbox' ? false : '';
        }
        field.errors = null;
      });

      this.isPhoneVerified = false;
      this.currentStep = 'form';
      this.tokenRequestPending = false;
      this.phoneToken.value = null;
      this.phoneToken.errors = null;
    },

    async initFields(props) {
      if (props.reference) {
        this.fields.reference.value = props.reference;
      } else {
        this.fields.reference.value = document
          .querySelector('.btn-stock-notification')
          .getAttribute('data-product-reference');
      }

      await this.loadCustomerInfo();

      const fieldMappings = {
        gender: 'gender',
        title: 'title',
        mobilePhone: 'phoneNumber',
        ...(this.isPhoneVerificationEnabled
          ? { firstName2: 'firstName', lastName2: 'lastName' }
          : { firstName1: 'firstName', lastName1: 'lastName' }),
      };

      Object.entries(fieldMappings).forEach(([sourceField, targetField]) => {
        if (!this.customerInfo?.[sourceField]) {
          return;
        }

        this.fields[targetField].value = this.customerInfo[sourceField];
      });
    },

    async onSuccess() {
      this.addTracking();
      this.close();
    },

    addTracking() {
      window.tracking.pushEvent(window.tracking.getBackInStockTracking());
    },
  },
};
